import React from "react";
import { useLanguage } from "../context/LanguageContext";

export default function ASavoir() {
  const { t } = useLanguage();
  const data = t("pages.asavoir") || t("pages.aSavoir");

  if (!data) return null;

  return (
    <section className="bg-gradient-to-b from-[#071026] via-[#08101d] to-[#070b12] text-slate-100">
      <div className="py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <div className="bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-lg shadow-sm p-6">
            <h1 className="text-3xl font-semibold mb-2 text-slate-900 dark:text-slate-100">
              {data.title}
            </h1>

            {data.subtitle && (
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                {data.subtitle}
              </p>
            )}

            {data.intro && (
              <p className="text-gray-800 dark:text-gray-200 mb-4">
                {data.intro}
              </p>
            )}

            {data.items && (
              <ul className="list-decimal list-inside space-y-3 text-gray-800 dark:text-gray-200">
                {data.items.map((item, i) =>
                  typeof item === "string" ? (
                    <li key={i}>{item}</li>
                  ) : (
                    <li key={i}>
                      <div className="font-medium mb-1 text-gray-900 dark:text-gray-100">
                        {item.title}
                      </div>

                      {item.subitems && (
                        <ul className="list-disc ml-6 mt-2 space-y-1 text-gray-800 dark:text-gray-200">
                          {item.subitems.map((subitem, j) => (
                            <li key={j}>{subitem}</li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )
                )}
              </ul>
            )}

            {data.confirmation && (
              <p className="mt-6 text-gray-700 dark:text-gray-300">
                {data.confirmation}
              </p>
            )}

            {data.cancellation && (
              <div className="mt-6 p-4 rounded-md bg-yellow-50 dark:bg-yellow-900 border-l-4 border-yellow-400 dark:border-yellow-600 text-sm text-yellow-800 dark:text-yellow-100">
                <div className="font-semibold">{data.cancellation}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
